<template>
	<span>{{meetingTime}}</span>
</template>
<script>
	export default{
		name:'datetimeshow',
		props:{
			type:{
				type:String,
				default:'yMd'
			},
			stime:{
				type:String,
				default:''
			},
			etime:{
				type:String,
				default:''
			},
			splice:{
				type:String,
				default:'~'
			},
			spliceShow:{
				type:Boolean,
				default:true
			},
			loading:{
				type:Boolean,
				default:false
			}
		},
		data(){
			return {
				
			}
		},
		computed:{
			meetingTime:function(){
				var sd=new Date(this.stime),ed=new Date(this.etime);
				if(this.stime!=''){
					var smsg='',emsg='';
					let sdy=parseInt(sd.format("yyyy"));
					let sdM=parseInt(sd.format("MM"));
					let sdd=parseInt(sd.format("dd"));
					let sdh=parseInt(sd.format("hh"));
					let sdm=parseInt(sd.format("mm"));
					
					let edy=parseInt(ed.format("yyyy"));
					let edM=parseInt(ed.format("MM"));
					let edd=parseInt(ed.format("dd"));
					let edh=parseInt(ed.format("hh"));
					let edm=parseInt(ed.format("mm"));
					
					if(this.type.indexOf('y')!=-1){
						smsg+=sdy+'年';
					}
					if(this.type.indexOf('M')!=-1){
						smsg+=sdM+'月';
					}
					if(this.type.indexOf('d')!=-1){
						smsg+=sdd+'日';
					}
					if(this.type.indexOf('h')!=-1){
						smsg+=sdh+'点';
					}
					if((this.type.indexOf('m')!=-1&&sdm!=0)||this.type=='hm'){
						smsg+=sdm+'分';
					}
					if(this.etime!=''){
						if(this.type.indexOf('y')!=-1&&sdy!=edy){
							emsg+=edy+'年';
						}
						if(this.type.indexOf('M')!=-1&&sdM!=edM){
							emsg+=edM+'月';
						}
						if(this.type.indexOf('d')!=-1&&sdd!=edd){
							emsg+=edd+'日';
						}
						if(this.type.indexOf('h')!=-1){
							emsg+=edh+'点';
						}
						if(this.type.indexOf('m')!=-1&&edm!=0){
							emsg+=edm+'分';
						}
					}
					if(this.loading){
						smsg+=this.etime==''?this.splice+'待定':this.spliceShow?emsg==''?'':this.splice+emsg:this.splice+emsg;
					}else if(this.spliceShow){
						smsg+=emsg==''?'':this.splice+emsg;
					}else{
						smsg+=this.splice+emsg;
					}
				}
				
				return smsg;
			}
		}
		
	}
</script>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Meeting/Attend/expend-datetimeshow.vue